// dropZeros removes decimals if price has no cents
// dropZeros:true  = 239 -> $239 || 239.23 -> $239.23
// dropZeros:false = 239 -> $239.00 || 239.23 -> $239.23
export const formatPrice = (price, dropZeros) => {
  if (price == null || price <= 0) return '';
  if (price < 1 && price !== 0) return `${(price * 100).toFixed()}¢`;
  if (dropZeros && price % 1 === 0) return `$${parseFloat(price)}`;
  return `$${parseFloat(price).toFixed(2)}`;
};

export const formattedReward = ({
  rewardPercent,
  rewardAmountPerOrder,
  rewardFixedPrice
}, dropZeros) => {

  if (rewardPercent) return `${rewardPercent}%`;
  // No savings messaging for rewardFixedPrice scenarios
  if (rewardFixedPrice) return '';
  return formatPrice(rewardAmountPerOrder, dropZeros);
};

const iOSPlatforms = [
  'iPad Simulator',
  'iPhone Simulator',
  'iPod Simulator',
  'iPad',
  'iPhone',
  'iPod'
];

export const isAppleTouch = () => (
  navigator?.platform && navigator?.userAgent
  && (iOSPlatforms.includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes('Mac') && 'ontouchend' in document))
);

export const getPreviewImages = ({ allListProductsAndAnchor, channel, itemIds }) => {
  const numPreviewImages = channel === 'mobile' ? 3 : 4;
  return itemIds.slice(0, numPreviewImages).map((itemId) => (
    {
      url: allListProductsAndAnchor.get(itemId).media?.image?.url,
      itemId
    }
  ));
};
